<template>
    <div class="d-flex w-100">
      <div class="d-flex w-100">
        <div class="col-md-3">
          <inqueryDetailsInformationQmaLv  v-on:Reload="setReload" ref="informationQmaLv" :propQma="propQma"></inqueryDetailsInformationQmaLv>
        </div>
        <div class="col-md-9">
          <inqueryDetailsTableQmaLv :qma="qma" ref="registerTable" :propQma="propQma" :idQma="idQma"></inqueryDetailsTableQmaLv>
        </div>
      </div>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
// import inqueryDetailsInformationQma from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsInformationApr/inqueryDetailsInformationApr'
import inqueryDetailsInformationQmaLv from '@/views/private/qma/inqueryQma/inqueryQmaLv/components/inqueryQmaLvTable/components/inqueryQmaLvDetails/components/inqueryDetailsInformationQmaLV/inqueryDetailsInformationQmaLv.vue'
// import inqueryDetailsTableQma from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/inqueryDetailsTableApr'
import inqueryDetailsTableQmaLv from '@/views/private/qma/inqueryQma/inqueryQmaLv/components/inqueryQmaLvTable/components/inqueryQmaLvDetails/components/inqueryDetailsTableQmaLv/inqueryDetailsTableQmaLv.vue'
import { loading } from '@/shared/utils/UIHelper'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'

export default {
  name: 'inqueryQmaPivsDetails',
  components: {Multiselect, inqueryDetailsInformationQmaLv, inqueryDetailsTableQmaLv},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      idQma: null,
      propQma: [],
      qma: 0
    }
  },
  props: {

  },
  mounted () {
  },
  methods: {
    onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.idQma = value
        this.getQmaSelected(this.idQma)
      })
    },
    getQmaSelected (value) {
      loading.push()
      inqueryQmaRepository.GetQmaSelected(value)
        .then(response => {
          loading.pop()
          this.propQma = response.data
          this.$refs.informationQmaLv.onLoad(this.propQma)
          this.$refs.registerTable.onLoad(this.propQma)
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    setReload () {
      this.onLoad()
    }
  }
}

</script>

  <style scoped>
  .col-md-3{
  padding-right: 0;
  padding-left: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaLv/components/inqueryQmaLvTable/components/inqueryQmaLvDetails/inqueryQmaLvDetails.vue